import request from '@/utils/request'
import axios from 'axios'
import {Notify} from "vant";

export function getCityList(params) {
  // 城市
  return request({
    url: '/common/city',
    method: 'post',
    params
  })
}

export function getTradeList(data) {
  // 行业
  return request({
    url: '/common/trade',
    method: 'post',
    data
  })
}

export function getDistrictList(params) {
  // 获取地区列表
  return request({
    url: '/common/district',
    method: 'post',
    params
  })
}

export function uploadImg(data) {
  // 上传
  return new Promise((reolove, reject) => {
    axios({
      url: process.env.VUE_APP_BASE_API + '/common/uploadBase64Img',
      method: 'post',
      data,
      timeout: 2000,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => {
      if (res.data.code === 0) {
        reolove(res.data)
      } else {
        reject()
      }
    }).catch(() => {
      reject()
    })
  })
}

export function getTransfer(params) {
  // 发布
  return request({
    url: '/shop/transfer',
    method: 'post',
    params
  })
}

export function publish(headers, params) {
  // 上传
  return request({
    url: '/shop/pub/publish/transfer',
    method: 'post',
    params,
    headers
  })
}

export function getPlaceOrder(headers, params) {
  // 支付
  return request({
    url: '/pay/h5',
    method: 'post',
    headers,
    params
  })
}

export function getConfig() {
  // 配置项
  return request({
    url: '/common/basic',
    method: 'post'
  })
}

export function setSuggestion(params) {
  // 提交意见/投诉
  return request({
    url: '/common/opinion',
    method: 'post',
    params
  })
}

export function getPayResult(headers, params) {
  // 支付订单查询
  // return request({
  //   url: '/productPayQuery',
  //   method: 'post',
  //   params
  // })
  return new Promise((reolove, reject) => {
    axios({
      baseURL: process.env.VUE_APP_BASE_API,
      url: '/pay/productPayQuery',
      method: 'post',
      headers,
      params
    }).then(res => {
      if (res.data.code === 0) {
        reolove(res.data)
      } else {
        reject()
      }
    }).catch(() => {
      reject()
    })
  })
}

export function getRentList(params) {
  // 求租列表查询
  return request({
    url: '/shop/rent',
    method: 'post',
    params
  })
}

export function getUserInfo(data) {
  const { token, timestamp, nonce, signature } = data
  // 用户信息
  return new Promise((resolve, reject) => {
    axios({
      baseURL: process.env.VUE_APP_BASE_API,
      url: '/user/info',
      method: 'post',
      headers: {
        token,
        timestamp,
        nonce,
        signature
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        resolve(res.data)
      } else {
        if (res.data.code === 1000) {
          resolve(res.data)
        } else {
          Notify(res.data.msg)
        }
        resolve(undefined)
      }
    }).catch(() => {
      resolve(undefined)
    })
  })
}

export function sendCode(params) {
  // 发送验证码
  return request({
    url: '/sms/sendCode',
    method: 'post',
    params
  })
}

export function login(params) {
  // 登录
  return request({
    url: '/login/phone',
    method: 'post',
    params
  })
}

export function wxLogin(params) {
  // 微信登录
  return request({
    url: '/login/code',
    method: 'post',
    params
  })
}

export function myPublish(headers, params) {
  // 用户信息
  return request({
    url: '/user/publish',
    method: 'post',
    headers,
    params
  })
}

export function transferDetail(params) {
  // 转让信息详情
  return request({
    url: '/shop/transfer/detail',
    method: 'post',
    params
  })
}

export function editPublish(headers, params) {
  // 修改发布
  return request({
    url: '/user/editPublish',
    method: 'post',
    headers,
    params
  })
}

export function deletePublish(headers, params) {
  // 删除发布
  return request({
    url: '/user/deletePublish',
    method: 'post',
    headers,
    params
  })
}

export function wxPay(headers, params) {
  // 微信支付
  return request({
    url: '/pay/pub',
    method: 'post',
    headers,
    params
  })
}

export function commonConfig(params) {
  // 微信配置
  return request({
    url: '/common/page/options',
    method: 'post',
    params
  })
}

export function getWxLoginUrl(params) {
  return request({
    url: '/login/getWxLoginUrl',
    method: 'post',
    params
  })
}

